module.exports = __webpack_public_path__ + "static/media/york-17.94f91b81.jpg";